import { render } from "./ClickQRPaymentDetails.vue?vue&type=template&id=79a9032f&ts=true"
import script from "./ClickQRPaymentDetails.vue?vue&type=script&lang=ts"
export * from "./ClickQRPaymentDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__